import React from "react";
import classNames from "classnames";

import Typography from "@/components/Typography";
import Container from "@/components/Container";
import { GridColumns } from "@/components/Container/Container.interface";
import useRequest from "@/helpers/useRequest";
import { apiPath } from "@/helpers/apiPath";
import ArticleTile from "@/components/FeedTiles/ArticleTile";
import { ArticleTileProps } from "@/helpers/pageHelpers/Article/interface";

import styles from "./Related.module.scss";
import { RelatedContentInterface, RelatedInterface } from "./Related.interface";

export const Related: React.FC<RelatedInterface> = ({
  data: initialData,
  slug,
}) => {
  const { data } = useRequest(apiPath.RELATED_ARTICLES(slug), {
    initialData,
  }) as RelatedContentInterface;

  return data?.length ? (
    <div
      className={classNames(
        styles.related,
        data.length === 1 && styles.hideOnDesktop
      )}
    >
      <Container>
        <Typography className={styles.heading} component="h5">
          Podobne
        </Typography>
      </Container>

      <Container grid={GridColumns.Three} className={styles.carousel}>
        {data?.map((article, index) => {
          return (
            <ArticleTile
              key={index}
              variant="small"
              className={styles.item}
              {...(article as ArticleTileProps)}
              publishedAt={undefined}
            />
          );
        })}
      </Container>
    </div>
  ) : null;
};

export default Related;
